import React from 'react';
import AccountBox from '@mui/icons-material/AccountBox';
import Build from '@mui/icons-material/Build';
import Close from '@mui/icons-material/Close';
import Home from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Link } from '../../atoms/Link';
import { Logo } from '../../atoms/Logo';
import { AppBarStyled, ToolbarStyled } from './Header.styled';
import { IHeaderProps } from './Header.types';

export const Header: React.FC<IHeaderProps> = ({ pages, onToggleMenu, isActive }) => {
  const [isSideMenuOpen, setIsSideMenuOpen] = React.useState<boolean>(false);

  const navigate = useNavigate();

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          display: {
            xs: 'none',
            md: 'flex',
          },
        }}
      >
        <Container maxWidth={false}>
          <Toolbar disableGutters sx={{ width: '100%', display: 'flex' }}>
            <Box>
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
              >
                <Link to="/">
                  <Logo />
                </Link>
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexGrow: 1,
                gap: 6,
              }}
            >
              {pages.map((page) => (
                <Button
                  key={page.label}
                  color="secondary"
                  size="large"
                  onClick={() => navigate(page.value)}
                >
                  <FormattedMessage id={page.label} />
                </Button>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <AppBarStyled sx={{ display: { xs: 'flex', md: 'none' } }} position="sticky">
        <ToolbarStyled>
          <IconButton
            style={{ marginLeft: 0 }}
            onClick={onToggleMenu}
            edge="start"
            color="inherit"
            aria-label="menu"
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <MenuIcon
                style={{
                  position: 'absolute',
                  transform: `rotate(${isActive ? '90deg' : '0'})`,
                  opacity: isActive ? '0%' : '100%',
                  transition: '0.5s',
                }}
              />
              <Close
                style={{
                  position: 'absolute',
                  transform: `rotate(${isActive ? '0' : '-90deg'})`,
                  opacity: isActive ? '100%' : '0%',
                  transition: '0.5s',
                }}
              />
            </Box>
          </IconButton>
        </ToolbarStyled>
      </AppBarStyled>
      <Drawer onClose={() => setIsSideMenuOpen(false)} open={isSideMenuOpen}>
        <List
          style={{
            width: 250,
            height: '100vh',
            paddingTop: '72px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <ListItem button key="home">
            <ListItemIcon>
              <Home />
            </ListItemIcon>
            <ListItemText primary={<FormattedMessage id="menu.home" />} />
          </ListItem>
          <ListItem button key="offers">
            <ListItemIcon>
              <Build />
            </ListItemIcon>
            <ListItemText primary={<FormattedMessage id="menu.services" />} />
          </ListItem>
          <Divider style={{ marginTop: 'auto', marginBottom: '8px' }} />
          <ListItem button key="impressum">
            <ListItemIcon>
              <AccountBox />
            </ListItemIcon>
            <ListItemText primary={<FormattedMessage id="menu.impressum" />} />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};
